<template>
	<div class="guestcard">
		<guestcard-filter
			@submit="getGuestcards"
			@exceldataexport="getExcelDataExport"
			@csvdataexport="getCsvDataExport"
			:approvedMandators="approvedMandators"
			:appNameShort="appNameShort"
			:loadingGuestcardData="loading"
			:errorDataLoading="errorDataLoading"
		/>
		<br />
		<guestcard-table :guestcards="guestcardsTable" v-show="showGuestcardsTable" />
		<v-layout align-center justify-center class="dataLoading">
        <v-progress-circular
          indeterminate
          color="primary"
          v-show="loading"
        />
      </v-layout>
	</div>
</template>

<script>
import axios from 'axios'
import GuestcardTable from './GuestcardTable.vue'
import GuestcardFilter from './GuestcardFilter.vue'

export default {
	name: 'GuestcardReport',
	components: {
		GuestcardTable,
		GuestcardFilter,
	},
	props: ['approvedRoles'],
	data() {
		return {
			guestcardsTable: [],
			loading: false,
			showGuestcardsTable: false,
			rolesToHandle: this.approvedRoles,
			approvedMandators: [],
			appNameShort: 'rs',
			errorDataLoading: false,
		};
	},
	methods: {
		async getGuestcards(filterData) {
			try {
				this.loading = true
				// eslint-disable-next-line no-undef
				const res = await axios.post(`${config.baseAPIurl}/guestcard`, {
					mandator: filterData.mandator[0],
					dateFrom: filterData.dateFrom,
					dateTill: filterData.dateTill,
					guestcards: filterData.guestcards,
					addedservices: filterData.addedservices,
					serviceprovider: filterData.serviceprovider,
					productnames: filterData.productnames,
					productskus: filterData.productsku,
				})
				this.guestcardsTable = res.data
			} catch (err) {
				this.errorDataLoading = true
				setTimeout(() => {
					this.errorDataLoading = false
				}, 5000)
			} finally {
				this.loading = false
				this.showGuestcardsTable = true
			}
		},
		async getExcelDataExport(filterData) {
			try {
				this.loading = true
				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/guestcard/excel`,
					method: 'post',
					responseType: 'blob',
					data: {
						mandator: filterData.mandator[0],
						dateFrom: filterData.dateFrom,
						dateTill: filterData.dateTill,
						guestcards: filterData.guestcards,
						addedservices: filterData.addedservices,
						serviceprovider: filterData.serviceprovider,
						productnames: filterData.productnames,
						productskus: filterData.productsku,
					},
				})
				const filenameExtension = `${filterData.dateFrom}-${filterData.dateTill}`
				// eslint-disable-next-line no-undef
				saveAs(new Blob([response.data]), `guestcard${filenameExtension}.xlsx`);
			} catch (err) {
				this.errorDataLoading = true
				setTimeout(() => {
					this.errorDataLoading = false
				}, 5000)
			} finally {
				this.loading = false
			}
		},
		async getCsvDataExport(filterData) {
			try {
				this.loading = true
				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/guestcard/csv`,
					method: 'post',
					responseType: 'blob',
					data: {
						mandator: filterData.mandator[0],
						dateFrom: filterData.dateFrom,
						dateTill: filterData.dateTill,
						guestcards: filterData.guestcards,
						addedservices: filterData.addedservices,
						serviceprovider: filterData.serviceprovider,
						productnames: filterData.productnames,
						productskus: filterData.productsku,
					},
				});
				const filenameExtension = `${filterData.dateFrom}-${filterData.dateTill}`
				// eslint-disable-next-line no-undef
				saveAs(new Blob([response.data]), `guestcard${filenameExtension}.csv`)
			} catch (err) {
				this.errorDataLoading = true
				setTimeout(() => {
					this.errorDataLoading = false
				}, 5000)
			} finally {
				this.loading = false
			}
		},
	},
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #64c823;
}
</style>
